import { action } from 'typesafe-actions';
import { Types, INotification, INewContractNotification } from './types';

export const addNewContractNotifications = (
  newContractNotifications: INewContractNotification[]
) => action(Types.ADD_NOTIFICATIONS, { newContractNotifications });
export const removeNotifications = (notificationsToRemove: INotification[]) =>
  action(Types.REMOVE_NOTIFICATIONS, { notificationsToRemove });
